'use client';

export const ContactUsError = (props: { resetError: () => void }) => {
  return (
    <div className="flex flex-col place-items-center place-content-center gap-4">
      <h1>Sorry there was an error submitting your request</h1>
      <button
        // @TODO: Use Button Component - make sure this is a variant of our button component
        className="rounded-xl px-4 py-3 text-sm font-medium transition bg-primary-200 text-white ring-1 ring-inset ring-primary-500/50 dark:text-brand w-300 dark:bg-primary-500/10 dark:hover:bg-primary-500/10 dark:hover:text-primary-600 dark:hover:ring-primary-600"
        onClick={() => {
          props.resetError();
        }}
      >
        Please try again
      </button>
    </div>
  );
};
